jQuery(function ($) {
    //Home header carousel
    self = {};

    $(document).ready(function () {
        if ($('ul.wp-block-gallery.carousel').length) {
            $('ul.wp-block-gallery.carousel').flickity({
                adaptiveHeight: true,
                cellSelector: '.blocks-gallery-item',
                cellAlign: 'left',
                pageDots: false,
                imagesLoaded: true,
                on: {
                    ready: function () {
                        $(this).resize();
                    },
                },
            });

            //Try to fix for iOS13
            var tapArea, startX;
            tapArea = document.querySelectorAll('ul.wp-block-gallery.carousel');
            startX = 0;
            for (var item of tapArea) {
                item.ontouchstart = function (e) {
                    startX = e.touches[0].clientX;
                };
                item.ontouchmove = function (e) {
                    if (Math.abs(e.touches[0].clientX - startX) > 5 && e.cancelable) {
                        e.preventDefault();
                    }
                };
            }
        }


//Landing page carousels
        if ($('.landing-carousel').length) {
            var options = {
                cellAlign: 'left',
                groupCells: true,
                pageDots: false,
                imagesLoaded: true,
                arrowShape: {
                    x0: 10,
                    x1: 60,
                    y1: 50,
                    x2: 65,
                    y2: 50,
                    x3: 15,
                },
                contain: true,
                on: {
                    ready: function () {
                        var maxHeight = 0;
                        // Iteracja przez każdy slajd w celu znalezienia najwyższego
                        $('.landing-carousel .post-item').each(function() {
                            var cellHeight = $(this).height();
                            if (cellHeight > maxHeight) {
                                maxHeight = cellHeight;
                            }
                        });
                        // Ustawienie wysokości dla każdego slajdu
                        $('.landing-carousel .post-item').height(maxHeight);
                    },
                },
            };
            $('.landing-carousel').flickity(options);
            //Try to fix for iOS13
            var tapArea, startX;
            tapArea = document.querySelectorAll('.landing-carousel');
            startX = 0;
            for (var item of tapArea) {
                item.ontouchstart = function (e) {
                    startX = e.touches[0].clientX;
                };
                item.ontouchmove = function (e) {
                    if (Math.abs(e.touches[0].clientX - startX) > 5 && e.cancelable) {
                        e.preventDefault();
                    }
                };
            }
        }


        if ($('body').hasClass('page-template-template-landing-page')) {
            $(document).on('click', '.video-play', function () {
                $('#video-showbox').html('');
                var vidID = $(this).data('video');
                var vidHTML = '<iframe src="https://www.youtube.com/embed/' + vidID + '?autoplay=1&rel=0" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>';
                $('#video-coverbox').fadeIn('fast', function () {
                    $('#video-showbox').html(vidHTML);
                });
            });
            $(document).on('click', '#video-closebox, #video-coverbox', function () {
                $('#video-coverbox').fadeOut('fast', function () {
                    $('#video-showbox').html('');
                });
            });
        }
    });
});